import React, { FC } from 'react';
import { connect } from 'react-redux';

import sanityImgUtil from 'utils/sanityImgUtil';
import getDefaultArticleUrl from 'utils/getDefaultArticleUrl';
import getDefaultTopicUrl from 'utils/getDefaultTopicUrl';

import organizedTopic from 'state/selectors/organizedTopic';

import { Img } from 'components/base';
import { ItemContainer, ContentHubItemImage } from '../style';
import ItemHeader from '../ItemHeader';
import ItemDescription from '../ItemDescription';

import { Color } from 'styled/theme/colors';
import Language from 'constants/Language';

import {
  ArticleItem as IArticleItem,
  GlobalState,
  OrganizedTopic,
} from 'types';

interface PassedProps {
  item: IArticleItem;
  bgColor: Color;
  textColor: Color;
}

interface StoreProps {
  organizedTopic: OrganizedTopic;
}

type Props = PassedProps & StoreProps;

const ArticleItem: FC<Props> = ({
  item,
  bgColor,
  textColor,
  organizedTopic,
}) => {
  const button = {
    label: item.moduleTitle || item.title,
    link: getDefaultArticleUrl(item.slug),
  };

  return (
    <ItemContainer>
      <ItemHeader
        button={button}
        subtitle={item.topic.title}
        title={item.moduleTitle || item.title}
        subTitleSlug={getDefaultTopicUrl(organizedTopic, item.topic.slug)}
        textColor={textColor}
      />
      {item.heroImage.id && (
        <ContentHubItemImage
          as={Img}
          alt={item.heroImage.alt}
          src={sanityImgUtil(
            item.moduleImage.id ? item.moduleImage : item.heroImage,
            500
          )}
        />
      )}
      <ItemDescription
        description={item.moduleDescription}
        textColor={textColor}
        bgColor={bgColor}
      />
    </ItemContainer>
  );
};

const mapStateToProps = (state: GlobalState): StoreProps => ({
  organizedTopic: organizedTopic(state),
});

export default connect(mapStateToProps)(ArticleItem);
